import React from "react";
import CommunitySection from "../WebSite/CommunitySection/CommunitySection";
import ABNServices from "../OurServices/ABNServices";
import AgribusinessMainSection from "../AgribusinessMain/AgribusinessMainSection";
import HomeSubSection from "../WebSite/HomeSubSection/HomeSubSection";
import ABN from "../../images/ABN-network.gif";
import ABNBenefits from "../WebSite/Benefits/ABNBenefits";
import ABNNetworkOperator from "../ABNNetworkOperator/ABNNetworkOperator";
import ABNMainServices from "./ABNMainServices";
import NetworkOperatorPartnerBenefits from "../ForNetworKOperators/NetworkOperatorPartnerBenefits";
import Container from "@material-ui/core/Container";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import AgribusinessType from "../Agribusiness/AgribusinessType";
export default function ABNComponent() {
  // List of ABN Network Types
  const types = ["ADN", "ACN", "CBON", "CMN", "FEN"];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        //bannerTitle="Agribusiness Network is to create a Digital Trust among agribusiness"
        bannerTitle={"Agribusiness Newtork Turns Your Existing Network into a Scalable Revenue Engine"}
       // bannerbodycopy=" AgroDealer Network | Farm Enterprise Network | Contract Manufacturers Network |CBO Network"
       bannerbodycopy={"Activate and monetize your farmers, vendors, and partners through a unified Agribusiness Network built on digital trust."}
        className="abnbg" 
      />

      {/* Overview Section */}
      <div className="mt-5 mb-5">
        <h4 className="container-title text-center mx-md-4">Overview</h4>
        
        <HomeSubSection
          className="rowReverseAbout align-items-center"
         // listItems={<ABNBenefits />} 
          //description="ABN is a Blockchain-enabled online community for agribusiness to maximize profit. Agribusiness can join Agri Business Network to access the following benefits."
          description={"Agribusiness Network is a unified digital platform that enables agribusinesses to build, operate, and scale trusted ecosystems across their entire value chain. It connects Agro-Dealer Networks, Farm Enterprise Networks, Contract Manufacturer Networks, CBO Networks, and Logistics Networks into a single, coordinated system—enabling seamless collaboration, real-time visibility, and efficient value exchange among all stakeholders. Designed to solve the persistent challenges of fragmented operations, limited visibility, and vendor dependency, the Agribusiness Network replaces disconnected tools with an integrated, enterprise-owned infrastructure. It brings data, workflows, and partner interactions onto one platform, eliminating silos and extending control beyond organizational boundaries. This allows enterprises to make faster, more informed decisions while ensuring transparency and trust across the ecosystem. For organizations that already manage large vendor and partner networks, the Agribusiness Network acts as a powerful monetization engine. It transforms existing relationships into structured, scalable systems by standardizing workflows and enabling digital trust. Through orchestrated transactions, services, and data flows, businesses can unlock new revenue streams, improve operational efficiency, and build more resilient, future-ready agribusiness ecosystems."}
          src={ABN} 
        />
      </div>

      {/* Agribusiness Network Types */}
      <div className="main-wrapper">
        <AgribusinessType types={types} md={2} title="SMB-ABN Types" />
      </div>

      {/* Services of ABN */}
      <div>
        <ABNMainServices />
      </div>

      {/* Features of ABN  */}
    {/*  { <div className="main-wrapper">
        <ABNServices />
      </div>} */}

      {/* Benefits of ABN */}
      <div className="pb-0">
        <Container className="subSectionWrapper">
          <NetworkOperatorPartnerBenefits title="Benefits" />
        </Container>
      </div>

      {/* Beneficiaries section listing all Core Agribusiness */}
      <div className="main-wrapper">
        <div className="subSectionWrapper">
          <h4 className="container-title text-center mx-md-4">
            ABN BENEFICIARIES - CORE AGRIBUSINESS
          </h4>
          <AgribusinessMainSection />
        </div>
      </div>

      {/* Beneficiaries section listing all partners  */}
      <CommunitySection exploreBtn="true" />

      {/* ABN Network Operator Section */}
      <ABNNetworkOperator />
    </>
  );
}

